<script setup lang="ts">
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';
import { VButton } from '@shared/component/VButton';
import VCallToAction from '@shared/component/VCallToAction/VCallToAction.vue';
import VContentBox from '@shared/component/VContentBox/VContentBox.vue';
import VButtonGroup from '@shared/component/VButtonGroup/VButtonGroup.vue';
import { useClaims } from '@auth/useClaims';
import { signOut } from '@auth/util';

const claims = useClaims();
</script>
<template>
  <VPageContainer>
    <VContentBox class="mt-6">
      <div class="flex flex-col items-center p-4 text-grey-700">
        <VCallToAction
          icon="far fa-file-check"
          class="py-16"
          title="Bedankt!"
          description="De samenwerkingsovereenkomst is succesvol ondertekend. Je zult het getekende exemplaar nog ontvangen in je mailbox."
        >
          <VButtonGroup>
            <VButton @click="signOut(true)" append-icon="far fa-sign-out" inverted>
              {{ claims.isTemporaryUser ? 'Sessie verlaten' : 'Uitloggen' }}
            </VButton>
            <VButton
              v-if="!claims.isTemporaryUser"
              append-icon="fas fa-arrow-right"
              href="/app/aanvraag/recente-activiteiten/"
            >
              Verder naar SUREnet
            </VButton>
          </VButtonGroup>
        </VCallToAction>
      </div>
    </VContentBox>
  </VPageContainer>
</template>
